import { Viewport3DRenderMode } from '@core/types';

const getServerSetting3DRenderMode = () => {
	const query = new URLSearchParams(window.location.search);
	let serverSetting3DRender = query.get('3drendering');
	if (serverSetting3DRender) {
		serverSetting3DRender = serverSetting3DRender.toLowerCase();
	}
	switch (serverSetting3DRender) {
		case 'client':
			return Viewport3DRenderMode.Client;
		case 'server':
			return Viewport3DRenderMode.Server;
		default:
			return null;
	}
};

export default getServerSetting3DRenderMode;
